import { render, staticRenderFns } from "./grade-level-card.vue?vue&type=template&id=0c25e4ec&scoped=true"
import script from "./grade-level-card.ts?vue&type=script&lang=ts&external"
export * from "./grade-level-card.ts?vue&type=script&lang=ts&external"
import style0 from "./grade-level-card.scss?vue&type=style&index=0&id=0c25e4ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25e4ec",
  null
  
)

export default component.exports